import { Card, CardAction, CardDescription, CardHeader, CardTitle, cn } from "@tellescope/ui";
import { Button } from "@tellescope/design-system";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export interface NavTakeoverCardProps {
  title: string;
  description: string;
  className?: string;
  onTitleClick?: () => void;
}

export const NavTakeoverCard = ({ title, description, className, onTitleClick }: NavTakeoverCardProps) => {
  const navigate = useNavigate();

  return (
    <Card className={cn("gap-0 py-3 shadow-sm mx-2 mt-2 rounded-sm border", className)}>
      <CardHeader className="gap-0.5 px-3 min-w-0">
        {onTitleClick ? (
          <Button variant="link" className="h-auto min-w-0 shrink p-0 justify-start" onClick={onTitleClick}>
            <CardTitle className="text-sm truncate">{title}</CardTitle>
          </Button>
        ) : (
          <CardTitle className="text-sm truncate">{title}</CardTitle>
        )}
        <CardDescription className="text-xs truncate">{description}</CardDescription>
        <CardAction className="row-span-2 self-center">
          <Button
            variant="ghost"
            iconOnly
            color="muted"
            size="sm"
            onClick={() => navigate(-1)}
            data-trackingid="nav-takeover-card-close"
          >
            <X />
          </Button>
        </CardAction>
      </CardHeader>
    </Card>
  );
};
